import { FC, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Loader from 'react-loader-spinner';

import { getCreditCardInfo, clearUserError, deleteCreditCardInfo } from 'modules/user/actions';
import { dispatch } from 'store';
import { RootState } from 'types';
import { STRIPE_PK } from 'config';

import { LanguagesSelect } from 'views/components';
import logo from 'assets/images/logo.svg';
import styles from './CreditCardDetails.module.css';
import { setNotification } from 'modules/app/actions';
import texts from './texts';
import { CardForm } from './CardForm';
import card from 'assets/images/card.png';
import { t } from 'utils';

export const CreditCardDetails: FC = () => {
  const { creditCards, loading } = useSelector((state: RootState) => state.user);

  const { notification } = useSelector((state: RootState) => state.app);
  const stripePromise: any = STRIPE_PK && loadStripe(STRIPE_PK);

  useEffect(() => {
    dispatch(clearUserError());
    dispatch(getCreditCardInfo.request());
  }, []);

  useEffect(() => {
    if (notification.status && notification.type === 'success') {
      NotificationManager.success(notification.text);
      dispatch(setNotification(false));
    }
  }, [notification]);

  const deleteCardHandler = useCallback((id: number) => {
    dispatch(deleteCreditCardInfo.request(id));
  }, []);

  return (
    <div className={styles.wrap}>
      <div className={styles.top}>
        <Link to="/dashboard">
          <img className={styles.logo} src={logo} alt="Logo" />
        </Link>
        <LanguagesSelect />
      </div>
      <div>
        <Link className={styles.link} to="/dashboard">
          {t(texts.creditCard.backToDashboard)}
        </Link>
      </div>
      <h1 style={{ fontSize: 40, fontWeight: 'bold', lineHeight: '50px' }}>
        {t(texts.creditCard.title)}
      </h1>
      {loading ? (
        <div
          style={{
            display: 'flex',
            height: '400px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Loader type="ThreeDots" color="#000" height={30} width={50} />
        </div>
      ) : (
        <>
          {creditCards.length > 0 &&
            creditCards.map(el => (
              <div className={styles.creditCard}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={card} style={{ width: '36px', height: '22px', marginRight: '10px' }} />

                  <p onClick={() => deleteCardHandler(el.id)} className={styles.delete}>
                    {t(texts.creditCard.delete)}
                  </p>
                </div>
                <div style={{ height: 1, backgroundColor: 'grey', width: '100%' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p
                    style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      textTransform: 'capitalize',
                      color: 'grey',
                    }}
                  >
                    {el.brand} **{el.last4}
                  </p>
                  <p
                    style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      textTransform: 'capitalize',
                      color: 'grey',
                    }}
                  >
                    {el.exp_month}/{el.exp_year}
                  </p>
                </div>
              </div>
            ))}
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <Elements stripe={stripePromise}>
              <CardForm />
            </Elements>
          </div>
        </>
      )}
    </div>
  );
};
